var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"gallery",class:[
    'gallery--' + _vm.width
  ]},_vm._l((_vm.images),function(item,key){return _c('li',{key:("item" + key),staticClass:"item",class:[
      'item--' + _vm.columns,
      {
        'item--highlight': item.highlight
      }
    ]},[_c('div',{staticClass:"item__image",class:{
        'item__image--landscape': item.image.width > item.image.height,
        'item__image--portrait': item.image.height >= item.image.width,
        'item__image--caption': item.caption !== '',
      }},[_c('img',{attrs:{"src":item.image.url},on:{"click":function($event){return _vm.highlight(_vm.images, key)}}}),(_vm.width === 'floorplan')?_c('p',{staticClass:"note"},[(_vm.note !== '')?_c('span',{domProps:{"innerHTML":_vm._s(_vm.note)}}):_c('span',[_vm._v(" Click to enlarge ")])]):_vm._e()]),(item.caption !== '')?_c('p',{staticClass:"note",domProps:{"innerHTML":_vm._s(item.caption)}}):_vm._e()])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }